/* KANON `Programy v2 - D3 (0.8)` — the master pane's toolbar, transcribed.
 *
 * Read off the rendered specimen at 1512×1000:
 *   toolbar  padding 10.5 13 9, gap 6.5, align centre
 *   search   flex 1, height 27 — `shared/ui/SearchField` at `size="compact"`
 *   filter   27 square, radius 9, --bg-chip over a --border hairline, icon 13.5
 *   dot      5.5 across, top 4 right 4, --accent-grad under a 1.5 --bg-chip ring
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

/* The 27px filter square moved to `shared/ui/filterSquare.module.css` on 17 September 2026, on its
 * second and third consumers — the exercise library's toolbar draws two of them at the same size,
 * the same fill and the same radius, because its KANON specimen transcribes this toolbar verbatim.
 * Nothing about the square changed in the move; what is left here is the toolbar's own layout. */

.toolbar {
  display: flex;
  flex: none;
  gap: var(--space-6-5px);
  align-items: center;
  padding: var(--space-10-5px) var(--space-13px) var(--space-9px);
}
